"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwPodCol = _interopRequireDefault(require("./CwPodCol.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var CwPodCol = function CwPodCol(props) {
  var getSectionHeader = function getSectionHeader() {
    if (props.sectionHeader || props.ghostSectionHeader) {
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(_CwPodCol.default.sectionHeader, (0, _defineProperty2.default)({}, _CwPodCol.default.ghostSectionHeader, props.ghostSectionHeader))
      }, props.ghostSectionHeader ? 'expect(jkenoyer).toBeFalsy()' : props.sectionHeader, props.sectionHeaderElements);
    }

    return null;
  };

  return _react.default.createElement("div", {
    style: {
      flexGrow: props.colSpan
    },
    className: (0, _classnames.default)(_CwPodCol.default.podCol, props.sectionHeader ? _CwPodCol.default.podColWithSectionHeader : _CwPodCol.default.podColWithoutSectionHeader, props.className)
  }, getSectionHeader(), props.children);
};

CwPodCol.propTypes = {
  sectionHeader: _propTypes.default.string,
  ghostSectionHeader: _propTypes.default.bool,
  sectionHeaderElements: _propTypes.default.arrayOf(_propTypes.default.element),
  colSpan: _propTypes.default.number,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]),
  className: _propTypes.default.string
};
CwPodCol.defaultProps = {
  colSpan: 1
};
var _default = CwPodCol;
exports.default = _default;